// src/components/atomicDesignDesktop/TextInputMobile.tsx
import React, { FC, useState } from 'react';

interface TextInputProps {
	width: number;
	title?: string;
	mandatory?: boolean;
	type: string;
	startIcon?: string;
	placeholder?: string;
	value: string;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	disabled?: boolean;
	loading?: boolean;
	wrong?: boolean;
	wrongMessage?: string;
}

const TextInputMobile: FC<TextInputProps> = ({
	width,
	title,
	mandatory,
	type,
	startIcon,
	placeholder,
	value,
	onChange,
	disabled,
	loading,
	wrong,
	wrongMessage,
}) => {
	const [showPassword, setShowPassword] = useState(false);
	const handleClickShowPassword = () => setShowPassword(!showPassword);
	
	const inputType = type === 'password' && showPassword ? 'text' : type;
	
	return (
		<div style={{ position: "relative", userSelect: 'none'}}>
			{title && (
				<div
					style={{
						marginBottom: 3,
						marginLeft: 6,
						fontWeight: 600,
						fontSize: 12,
						color: '#323E48',
					}}
				>
					{title} {mandatory && '*'}
				</div>
			)}
			<div
				style={{
					width: width,
					height: 26,
					background: disabled ? "#EDEDED" : '#FFFFFF',
					boxShadow: '0px 1px 6px #00000029',
					borderRadius: 5,
					border: wrong ? '2px solid red' : '1px solid #00000029',
					display: 'flex',
					alignItems: 'center',
					padding: '0 10px',
					boxSizing: 'border-box',
				}}
			>
				{startIcon && (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							fontSize: '18px',
							color: '#cccccc',
							width: 60,
						}}
					>
						{startIcon.length > 1 ? (
							<img
								src={startIcon}
								alt="icon"
								style={{ width: 32, height: 32 }}
							/>
						) : (
							<div
								style={{
									width: 32,
									height: 32,
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									fontSize: 15,
									color: '#969DA2',
									marginTop: -3,
									marginLeft: -5,
								}}
							>
								{startIcon}
							</div>
						)}
					</div>
				)}
				{loading &&
					<img
						src="/images/loading.gif"
						alt="loading"
						style={{
							position: 'absolute',
							right: 0,
							width: 35,
							height: 35
						}}
					/>
				}
				<input
					type={inputType}
					placeholder={placeholder ? placeholder : ''}
					value={value}
					onChange={disabled ? () => {} : onChange}
					className="custom-input"
					style={{
						width: '100%',
						border: 'none',
						outline: 'none',
						fontSize: 13,
						color: '#323E48',
						background: disabled ? '#EDEDED' : 'none',
						flex: 1,
						cursor: disabled ? 'not-allowed' : 'text',
						marginLeft: startIcon?.length === 1 ? -30 : 0,
					}}
				/>
				{type === 'password' && (
					<button
						onClick={handleClickShowPassword}
						style={{
							background: 'none',
							border: 'none',
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							color: showPassword ? '#FF4D00' : '#cccccc',
						}}
					>
						{showPassword ? (
							<img
								src="/images/password-visible.svg"
								alt="eye"
								style={{ width: 32, height: 32 }}
							/>
						) : (
							<img
								src="/images/password-hidden.svg"
								alt="eye"
								style={{ width: 32, height: 32 }}
							/>
						)}
					</button>
				)}
				{wrong && (
					<div
						style={{
							position: 'absolute',
							bottom: -20,
							left: 5,
							fontSize: 12,
							color: 'red',
						}}
					>
						{wrongMessage}
					</div>
				)}
			</div>
		</div>
	);
};

export default TextInputMobile;
